import { Component, OnInit } from '@angular/core';
import { differenceInCalendarDays } from 'date-fns';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-daterange',
  templateUrl: './app-date-range.component.html',
  styles: [
    `
      nz-date-picker ::ng-deep .ant-calendar-picker {
        width: 100%;
      }
      nz-date-picker,
      nz-time-picker {
        width: 100%;
      }
      .form-control-error {
        z-index: 4;
      }
    `,
  ],
})
export class AppDateRangeComponent extends FieldComponent implements OnInit {
  style: string;

  datePlaceHolder = ['Fecha inicial', 'Fecha final'];

  disabledDate = (current: Date): boolean => {
    if (this.minValue && differenceInCalendarDays(current, this.minValue) < 0) {
      return true;
    } else if (this.maxValue && differenceInCalendarDays(current, this.maxValue) > 0) {
      return true;
    }
    return false;
  };
}
